import styled from 'styled-components'
import { FaTimes } from 'react-icons/fa'

const CloseText = styled(FaTimes)`
  color: ${({ theme }) => theme.palette.grayscale[5]};
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.palette.grayscale[0]};
  }
`;

export default CloseText
